import { createContext } from 'react';

import { FEATURE_FLAG_DEFAULTS } from '#helper/feature-flags';

const FeatureFlagContext = createContext(FEATURE_FLAG_DEFAULTS);

export default FeatureFlagContext;
